<template>
    <a-drawer
      :title="'外事接待-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%"
    >
        <div class="input-box">
            <p>接待学院：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.receiveDepartmentCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>日期：</p>
            <a-date-picker class="input" v-model="info.receiveDate" @change="(date, dateString)=>{info.receiveDate=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>来访国家：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.visitingCountry" />
        </div>
        <div class="input-box">
            <p>来访单位：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.visitingUnit" />
        </div>
        <div class="input-box">
            <p>来访人员：</p>
            <a-textarea class="input" :rows="3" :disabled="actionName=='查看'" v-model="info.visitors" />
        </div>
        <div class="input-box">
            <p>来访人数：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.visitorNumber" />
        </div>
        <div class="input-box">
            <p>来访目的：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.visitPurpose" />
        </div>
        <div class="input-box">
            <p>达成意向：</p>
            <a-textarea class="input" :rows="4" :disabled="actionName=='查看'" v-model="info.reachIntention" />
        </div>
        <div class="input-box">
            <p>参加人员：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.participants" />
        </div>
        <div class="input-box">
            <p>备注：</p>
            <a-textarea class="input" :rows="4" :disabled="actionName=='查看'" v-model="info.remark" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/international/reception'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    receiveDepartmentCode:null,
                    receiveDate:null,
                    visitingUnit:null,
                    visitingCountry:null,
                    visitors:null,
                    visitorNumber:null,
                    visitPurpose:null,
                    reachIntention:null,
                    participants:null,
                    remark:null,
                },
                xyArr:[],
                jsArr:[],
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getDicts({dataCode:'XY',status:true}).then(res=>{
                    this.xyArr=res.data.dicts;
                    this.info.receiveDepartmentCode=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    receiveDepartmentCode:null,
                    receiveDate:null,
                    visitingUnit:null,
                    visitingCountry:null,
                    visitors:null,
                    visitorNumber:null,
                    visitPurpose:null,
                    reachIntention:null,
                    participants:null,
                    remark:null,
                };
                this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.consProjectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus','courseAttrName']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增外事接待成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改外事接待成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
